import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

const API = "https://labwayscientific.com/backend/wp-json/wc/v3";
const CK = "ck_e1c36267e6a5e3cb0198558262bf2096181b4a0b";
const CS = "cs_fc900ba31d63fade2cfba415abe8a599366c20b0";
const CATEGORY_ID = 19;

function Bestsellerproduct() {
  const [products, setProducts] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    fetch(
      `${API}/products?category=${CATEGORY_ID}&per_page=10&orderby=date&order=desc&consumer_key=${CK}&consumer_secret=${CS}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setProducts(data);
          return;
        }

        console.error("Unexpected API response:", data);
        setProducts([]);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        setProducts([]);
      });
  }, []);

  const settings = {
    dots: false,
    infinite: products.length > 4,
    autoplay: products.length > 1,
    autoplaySpeed: 2500,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="container fea-products-container">
      <div className="sec-title">
        <h2>Featured Products</h2>
        <div className="separator"></div>
      </div>

      <div style={{ position: "relative" }}>
        <button
          type="button"
          onClick={() => sliderRef.current?.slickPrev()}
          style={arrowLeft}
          aria-label="Previous products"
        >
          {"<"}
        </button>

        <button
          type="button"
          onClick={() => sliderRef.current?.slickNext()}
          style={arrowRight}
          aria-label="Next products"
        >
          {">"}
        </button>

        <div style={sliderWrap}>
          <Slider ref={sliderRef} {...settings}>
            {products.map((item) => (
              <div key={item.id} style={slideItem}>
                <div style={cardStyle}>
                  <Link
                    to={`/product/${item.id}`}
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <div style={imageWrap}>
                      <img
                        src={item.images?.[0]?.src || "/no-image.png"}
                        alt={item.name}
                        style={imageStyle}
                      />
                    </div>

                    <h4 style={titleStyle}>{item.name}</h4>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default Bestsellerproduct;

const cardStyle = {
  border: "1px solid #ddd",
  padding: "10px",
  background: "#fff",
  textAlign: "center",
  minHeight: "240px",
  margin: "0 10px",
};

const imageWrap = {
  height: "150px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const imageStyle = {
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
};

const titleStyle = {
  fontSize: "13px",
  marginTop: "10px",
  minHeight: "40px",
};

const arrowButtonBase = {
  position: "absolute",
  top: "40%",
  zIndex: 2,
  border: "none",
  background: "#97043a",
  color: "#fff",
  width: "34px",
  height: "34px",
  borderRadius: "50%",
  lineHeight: "34px",
  textAlign: "center",
};

const arrowLeft = {
  ...arrowButtonBase,
  left: "0",
};

const arrowRight = {
  ...arrowButtonBase,
  right: "0",
};

const sliderWrap = {
  padding: "10px 40px",
};

const slideItem = {
  padding: "10px 0",
};
